import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const Footer = () => {
  
  return (
    <Container>
      <Card body className='radius-15 text-light bg-black mb-4 shadow-lg'>
        <Row>
          <Col md={6}>
            <h4>About Us</h4>
            <p>
              The Devadiga community, rooted in rich Hindu traditions, serves as temple servants, musicians, and spirit players, preserving India's cultural heritage.
            </p>
            <Button variant="dark" href="https://www.instagram.com/devadiga.world/" target="_blank" className='mb-4'>
            <i className="bi bi-instagram"></i> Follow us on Instagram
            </Button>
          </Col>
          <Col md={6}>
            <h4>Contact Information</h4>
            <p>Udupi, India</p>
            <p>Email: devadiga.world@outlook.com</p>
          </Col>
        </Row>
        <hr></hr>
        <div className="text-center">
          <p>&copy; 2023 Devadiga World. All Rights Reserved.</p>
        </div>
      </Card>
    </Container>
  );
};

export default Footer;
